import { render, staticRenderFns } from "./InvoiceScanner.vue?vue&type=template&id=4846c24d&scoped=true"
import script from "./InvoiceScanner.vue?vue&type=script&lang=js"
export * from "./InvoiceScanner.vue?vue&type=script&lang=js"
import style0 from "./InvoiceScanner.vue?vue&type=style&index=0&id=4846c24d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4846c24d",
  null
  
)

export default component.exports